(function () {
  'use strict';

  const STORE_CONFIG = {
    peru: {
      domain: 'lentesdecontactoperu.com',
      country: 'PE',
      name: 'Peru',
      url: 'https://lentesdecontactoperu.com'
    },
    mexico: {
      domain: 'lentesdecontactomexico.mx',
      country: 'MX',
      name: 'Mexico',
      url: 'https://lentesdecontactomexico.mx'
    }
  };

  const COOKIE_NAME = 'geo_store_choice';
  const COOKIE_TTL_DAYS = 30;
  const POPUP_CLASS = 'geo-popup';

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const nameEQ = `${name}=`;
    const parts = document.cookie.split(';');
    for (let i = 0; i < parts.length; i += 1) {
      let cookie = parts[i];
      while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }
    return null;
  }

  function getCurrentStore() {
    const hostname = window.location.hostname.toLowerCase();
    if (hostname.indexOf(STORE_CONFIG.peru.domain) !== -1) return 'peru';
    if (hostname.indexOf(STORE_CONFIG.mexico.domain) !== -1) return 'mexico';
    return null;
  }

  async function fetchJson(url, options) {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Geo request failed: ${response.status}`);
    }
    return response.json();
  }

  async function getUserCountry() {
    const sources = [
      {
        url: 'https://ipapi.co/json/',
        parse: (data) => data && data.country_code
      },
      {
        url: 'https://ipwho.is/',
        parse: (data) => (data && data.success !== false ? data.country_code : null)
      }
    ];

    for (let i = 0; i < sources.length; i += 1) {
      try {
        const data = await fetchJson(sources[i].url, {
          method: 'GET',
          headers: { Accept: 'application/json' }
        });
        const country = sources[i].parse(data);
        if (country) return String(country).toUpperCase();
      } catch (error) {
        continue;
      }
    }

    return null;
  }

  function ensureStyles() {
    if (document.getElementById('geo-popup-styles')) return;

    const style = document.createElement('style');
    style.id = 'geo-popup-styles';
    style.textContent = `
      .${POPUP_CLASS} {
        position: fixed;
        right: 20px;
        bottom: 20px;
        width: min(360px, calc(100vw - 32px));
        padding: 20px 24px;
        background: #fff;
        color: #1f2937;
        border-radius: 14px;
        box-shadow: 0 14px 40px rgba(15, 23, 42, 0.16);
        z-index: 10000;
        animation: geoPopupIn .28s ease-out;
      }

      .${POPUP_CLASS}__content {
        margin-bottom: 16px;
        padding-right: 18px;
      }

      .${POPUP_CLASS}__text {
        margin: 0;
        font-size: 15px;
        line-height: 1.5;
      }

      .${POPUP_CLASS}__buttons {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
      }

      .${POPUP_CLASS}__btn {
        flex: 1 1 120px;
        min-height: 42px;
        border: 0;
        border-radius: 999px;
        padding: 10px 16px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: transform .2s ease, opacity .2s ease;
      }

      .${POPUP_CLASS}__btn:hover {
        transform: translateY(-1px);
      }

      .${POPUP_CLASS}__btn--primary {
        background-image: linear-gradient(274deg, rgba(92, 101, 160, 1) 19%, rgba(103, 147, 200, 1) 46%, rgba(109, 190, 209, 1) 74%, rgba(124, 182, 192, 1) 100%);
        color: #fff;
      }

      .${POPUP_CLASS}__btn--secondary {
        background: #f3f4f6;
        color: #374151;
      }

      .${POPUP_CLASS}__close {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 28px;
        height: 28px;
        border: 0;
        background: transparent;
        color: #6b7280;
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
      }

      .${POPUP_CLASS}.is-closing {
        animation: geoPopupOut .22s ease-in forwards;
      }

      @keyframes geoPopupIn {
        from { opacity: 0; transform: translateY(16px); }
        to { opacity: 1; transform: translateY(0); }
      }

      @keyframes geoPopupOut {
        from { opacity: 1; transform: translateY(0); }
        to { opacity: 0; transform: translateY(12px); }
      }

      @media (max-width: 480px) {
        .${POPUP_CLASS} {
          right: 12px;
          bottom: 12px;
          left: 12px;
          width: auto;
          padding: 18px;
        }

        .${POPUP_CLASS}__buttons {
          flex-direction: column;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function closePopup(popup) {
    if (!popup) return;
    popup.classList.add('is-closing');
    window.setTimeout(() => {
      if (popup.parentNode) popup.parentNode.removeChild(popup);
    }, 220);
  }

  function createPopup(message, buttons) {
    const existing = document.querySelector(`.${POPUP_CLASS}`);
    if (existing) existing.remove();

    const popup = document.createElement('div');
    popup.className = POPUP_CLASS;
    popup.innerHTML = `
      <button class="${POPUP_CLASS}__close" aria-label="Cerrar">&times;</button>
      <div class="${POPUP_CLASS}__content">
        <p class="${POPUP_CLASS}__text">${message}</p>
      </div>
      <div class="${POPUP_CLASS}__buttons">${buttons}</div>
    `;

    popup.querySelector(`.${POPUP_CLASS}__close`).addEventListener('click', function () {
      setCookie(COOKIE_NAME, 'dismissed', COOKIE_TTL_DAYS);
      closePopup(popup);
    });

    document.body.appendChild(popup);
    return popup;
  }

  function showRestOfWorldPopup(currentStore) {
    const store = STORE_CONFIG[currentStore];
    const popup = createPopup(
      `Parece que estas fuera de ${store.name}. Deseas continuar en esta tienda?`,
      `<button class="${POPUP_CLASS}__btn ${POPUP_CLASS}__btn--primary" data-action="stay">Continuar</button>`
    );

    popup.querySelector('[data-action="stay"]').addEventListener('click', function () {
      setCookie(COOKIE_NAME, 'dismissed', COOKIE_TTL_DAYS);
      closePopup(popup);
    });
  }

  function showRedirectPopup(targetStoreKey, stayStoreLabel) {
    const targetStore = STORE_CONFIG[targetStoreKey];
    const popup = createPopup(
      `Parece que tu ubicacion corresponde a ${targetStore.name}. Deseas cambiar de tienda?`,
      `
        <button class="${POPUP_CLASS}__btn ${POPUP_CLASS}__btn--primary" data-action="redirect">${targetStore.name}</button>
        <button class="${POPUP_CLASS}__btn ${POPUP_CLASS}__btn--secondary" data-action="stay">${stayStoreLabel}</button>
      `
    );

    popup.querySelector('[data-action="redirect"]').addEventListener('click', function () {
      setCookie(COOKIE_NAME, targetStoreKey, COOKIE_TTL_DAYS);
      window.location.href = targetStore.url;
    });

    popup.querySelector('[data-action="stay"]').addEventListener('click', function () {
      setCookie(COOKIE_NAME, 'dismissed', COOKIE_TTL_DAYS);
      closePopup(popup);
    });
  }

  async function init() {
    if (getCookie(COOKIE_NAME)) return;

    const currentStore = getCurrentStore();
    if (!currentStore) return;

    const userCountry = await getUserCountry();
    if (!userCountry) return;

    ensureStyles();

    if (userCountry === STORE_CONFIG.peru.country && currentStore === 'mexico') {
      showRedirectPopup('peru', STORE_CONFIG.mexico.name);
      return;
    }

    if (userCountry === STORE_CONFIG.mexico.country && currentStore === 'peru') {
      showRedirectPopup('mexico', STORE_CONFIG.peru.name);
      return;
    }

    if (userCountry !== STORE_CONFIG.peru.country && userCountry !== STORE_CONFIG.mexico.country) {
      showRestOfWorldPopup(currentStore);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
